import React, { useEffect } from 'react'
// import $ from 'jquery';

function OerlayModal(props) {


    useEffect(() => {

        const handleOutsideClick = (event) => {
            if (event.target.classList.contains('modal')) {
                props.onClose();
            }

        };



        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [props]);


    // $('#last-btn').click(function() {
    //     $('html, body').animate({
    //        scrollTop: $("#locations").offset().top}, 100);
    //  })
    return (
        <>
            <div
                className={`modal fade ${props.show ? 'show' : ''}`}
                id="exampleModalNew"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"

            >
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header border-0 colse_btn_new">
                            {props?.modalHeader}
                        </div>
                        <div class="modal-body text-center">
                            {props?.modalBody}
                            {/* <h2 class="fw-bold fs-5 p-lg-4">Answer some additional questions to make your bot even smarter! <br /><br>Want to update later? </br> let’s start testing below!</h2> */}
                        </div>
                        <div class="white_arrow">
                            <img src={`${process.env.PUBLIC_URL}/images/white_arrow.svg`} />

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OerlayModal